export const session = {
  get: key => {
    return JSON.parse(sessionStorage.getItem(key))
  },
  set: (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data))
  }
}
